import uuid from "react-uuid";
import store from "../../store";

export function getNextList(temp, parent) {
  var child = temp.filter((ele) => ele.parent === parent);
  return child;
}

export function getNextListFilter(temp, parent) {
  var child = temp.filter((ele) => ele.parent === parent && ele.isVisible);
  return child;
}

export function filterData(dataLink, index, selectedIndex) {
  var data = [];
  data = dataLink.slice(0, index + 1);
  data[index].selectedIndex = selectedIndex;

  if (dataLink.length > 0) {
    var flag = true;
    if (selectedIndex === "" || selectedIndex === "All") {
    } else {
      while (flag) {
        let temp = data[0].data[data[0].selectedIndex].asset_structure.parsed;
        var parent = null;
        if (index === 0) {
          parent = data[index].data[selectedIndex].asset_structure.parsed[0].id;
        } else {
          parent = data[index].data[data[index].selectedIndex].id;
        }
        var child = getNextList(temp, parent);
        if (child.length === 0) {
          flag = false;
        } else {
          data.push({
            data: child,
            selectedIndex: 0,
            isInstance: false,
          });
        }
        index++;
      }
    }
  }
  return data;
}

var isVisibleData = [];
export function filterDataUploaded(
  dataLink,
  index,
  selectedIndex,
  responseData
) {
  var data = [];
  data = dataLink.slice(0, index + 1);
  data[index].selectedIndex = selectedIndex;
  if (dataLink.length > 0) {
    var flag = true;
    if (selectedIndex === "" || selectedIndex === "All") {
    } else {
      let temp = data[0].data[data[0].selectedIndex].asset_structure.parsed;
      temp.forEach((ele) => {
        ele.isVisible = false;
        responseData.forEach((item) => {
          item.asset_class_node.forEach((node) => {
            if (node === ele.uuid) {
              ele.isVisible = true;
            }
          });
        });
      });
      isVisibleData = [];
      visibleCheck(temp, temp[0]);
      while (flag) {
        var parent = null;
        if (index === 0) {
          parent = isVisibleData[0].id;
        } else {
          parent = data[index].data[data[index].selectedIndex].id;
        }
        var child = getNextListFilter(isVisibleData, parent);
        if (child.length === 0) {
          flag = false;
        } else {
          data.push({
            data: child,
            selectedIndex: 0,
            isInstance: false,
          });
        }
        index++;
      }
    }
  }
  return data;
}

let visibleCheckRec = false;
export function visibleCheck(data) {
  data.forEach((ele) => {
    let nod = { ...ele };
    visibleCheckRec = nod.isVisible;
    if (!nod.isVisible) visibleCheckRecursion(data, nod);
    nod.isVisible = visibleCheckRec;
    isVisibleData.push(nod);
  });
}

export function visibleCheckRecursion(data, node) {
  var children = data.filter((ele) => ele.parent === node.id);
  if (children.length > 0) {
    if (children.filter((ele) => ele.isVisible).length > 0) {
      visibleCheckRec = true;
    } else {
      children.forEach((ele) => {
        visibleCheckRecursion(data, ele);
      });
    }
  }
}

var UniUUID = [];
export function singleUUID(dataLink, parent) {
  var child = dataLink.filter((ele) => ele.parent === parent.id);
  UniUUID.push(parent.uuid);
  if (child.length === 0) {
    return UniUUID;
  } else {
    child.forEach((ele) => {
      singleUUID(dataLink, ele);
    });
  }
}

export function getSelectDetails(dataLink) {
  var uuid = [];
  let parentNode = null;
  let isBlank = false;
  if (dataLink.length > 1) {
    if (
      dataLink[dataLink.length - 1].selectedIndex === "All" ||
      dataLink[dataLink.length - 1].selectedIndex === ""
    ) {
      if (dataLink[dataLink.length - 1].selectedIndex === "") {
        isBlank = true;
      }
      var parent = dataLink[dataLink.length - 1].data;
      let parentUUIDData = dataLink[dataLink.length - 2].data;
      let parentUUID = [];
      if (parentUUIDData.length > 0) {
        if (parentUUIDData[0].hasOwnProperty("asset_structure")) {
          parentUUID = [dataLink[0].data[0].asset_structure.parsed[0].uuid];
          parentNode = dataLink[0].data[0].asset_structure.parsed[0].uuid;
        } else {
          if (parent.length > 0) {
            let pId = parent[0].parent;
            parentUUIDData = parentUUIDData.filter((ele) => ele.id === pId);
            if (parentUUIDData.length > 0) {
              parentUUID = [parentUUIDData[0].uuid];
              parentNode = parentUUIDData[0].uuid;
            }
          }
        }
      }
      var main =
        dataLink[0].data[dataLink[0].selectedIndex].asset_structure.parsed;
      UniUUID = parentUUID;
      parent.forEach((ele) => {
        singleUUID(main, ele);
      });
      uuid = UniUUID;
    } else {
      uuid.push(
        dataLink[dataLink.length - 1].data[
          dataLink[dataLink.length - 1].selectedIndex
        ].uuid
      );
    }
  } else {
    var dataz =
      dataLink[0].data[dataLink[0].selectedIndex].asset_structure.parsed;
    if (dataz.length > 0) {
      uuid.push(dataz[0].uuid);
    }
  }
  var id = dataLink[0].data[dataLink[0].selectedIndex].id;
  return { uuid, id, parentNode, isBlank };
}

var newData = [];
let count = 0;
let testCount = 1000;
export function parserFunction(dataLink) {
  if (dataLink.length > 0) {
    var temp = { ...dataLink.filter((ele) => ele.parent === null)[0] };
    newData = [];
    count = dataLink.length;
    testCount = 1000 + dataLink.length;
    var newJson = helper(dataLink, temp);
    return newJson;
  }
}

export function helper(dataset, root, flag = false) {
  var idzz = flag ? testCount++ : root.id;
  newData.push({
    id: idzz,
    uuid: flag ? uuid() : root.instances.filter((ele) => ele.default)[0].id,
    isInstance: false,
    title: root.title,
    parent: root.parent,
    status: root.parent === null ? true : root.status,
    description: root.description,
  });
  if (root.instances.length > 1) {
    root.instances.forEach((ele, index) => {
      if (!ele.default) {
        var idval = 100 * (index + 1) + count;
        count++;
        newData.push({
          id: idval,
          uuid: uuid(),
          isInstance: true,
          title: ele.name,
          parent: idzz,
          status: root.status,
          description: root.description,
        });
        var result = dataset.filter((elet) => elet.parent === root.id);
        result.forEach((elet) => {
          helper(dataset, { ...elet, parent: idval }, true);
        });
      }
    });
  } else {
    var result = dataset.filter((ele) => ele.parent === root.id);
    result.forEach((ele) => {
      helper(dataset, ele, flag);
    });
  }
  return newData;
}

var data = [];
export function deleteInstanceFunction(dataset, instance, flag = false) {
  data = [];
  instance.forEach((item) => {
    var instanceSet = dataset.filter(
      (ele) => ele.uuid === item.instances[0].id
    );
    instanceSet.forEach((ele) => {
      deleteRecursion(dataset, ele);
    });
  });
  var actualData = dataset.filter(
    (ele) => ele.uuid !== instance[0].instances[0].id
  );
  if (flag) {
    var instanceSet2 = dataset.filter((ele) => ele.uuid === instance[0].id);
    data = [];
    deleteRecursion(dataset, instanceSet2[0]);
    if (data.length > 0) {
      max = Math.max(...dataset.map((o) => o.id));
      var parent = data.shift();
      var newDataset = data.map((ele) => {
        return { ...ele, id: ++max, uuid: uuid() };
      });
      var parentId = parent.parent;
      data.forEach((element, index) => {
        newDataset = newDataset.map((item) => {
          if (item.parent === element.parent) {
            return { ...item, parent: parentId };
          }
          return item;
        });
        parentId = newDataset[index].id;
      });
      actualData = actualData.concat(newDataset);
    }
  }
  return actualData;
}

export function deleteRecursion(dataset, ref) {
  var child = dataset.filter((item) => item.parent === ref.id);
  if (child.length === 0) {
    data.push(ref);
  } else {
    data.push(ref);
    child.forEach((ele) => {
      deleteRecursion(dataset, ele);
    });
  }
}

var data2 = [];
var data3 = [];
let max;
export function addInstanceFunction(
  dataset,
  parseData2,
  instance,
  parent,
  flag
) {
  var instanceSet = dataset.filter((ele) => ele.title === parent.title);
  var child = dataset.filter((ele) => ele.parent === instanceSet[0].id);
  max = Math.max(...dataset.map((o) => o.id));
  var dataReturnSet = [...dataset];
  if (flag) {
    if (child.length > 0) {
      if (child[0].isInstance) {
        child = dataset.filter((ele) => ele.parent === child[0].id);
      } else {
        dataReturnSet = dataReturnSet.filter(
          ({ id: id1 }) => !child.some(({ id: id2 }) => id2 === id1)
        );
      }
      data3 = [];
      instance.forEach((item) => {
        data3.push({
          id: ++max,
          parent: parent.id,
          title: item.name,
          uuid: item.id,
          description: instanceSet[0].description,
          status: instanceSet[0].status,
          isInstance: true,
        });
        child.forEach((ele) => {
          addRecursion(dataset, ele, max, max);
        });
        max = max + child.length + 3;
      });
      data2 = [];
      data2 = dataset;
    } else {
      data2 = [];
      var datzz = dataset.filter((ele) => ele.title === parent.title);
      datzz.forEach((ele) => {
        instance.forEach((item) => {
          data2.push({
            id: ++max,
            parent: ele.id,
            title: item.name,
            uuid: item.id,
            description: ele.description,
            status: ele.status,
            isInstance: true,
          });
        });
      });
      var returnData = dataset.concat(data2);
      return returnData;
    }
    dataReturnSet = dataReturnSet.concat(data3);
    return dataReturnSet;
  }
}

export function addRecursion(dataset, ref, parent, max) {
  var child = dataset.filter((item) => item.parent === ref.id);
  var maxT = Math.max(...data3.map((o) => o.id));
  if (child.length === 0) {
    data3.push({
      ...ref,
      parent: parent,
      id: ++maxT,
      uuid: uuid(),
    });
    ++max;
  } else {
    data3.push({
      ...ref,
      parent: parent,
      id: ++maxT,
      uuid: uuid(),
    });
    ++max;
    child.forEach((ele) => {
      addRecursion(dataset, ele, max, max);
    });
  }
}

export function getTreeStructure(dataset) {
  var dataResult = dataset.map((ele, index) => {
    return {
      ...ele,
      key: ele.id,
      name: ele.title,
      checked: 0,
      isOpen: false,
    };
  });

  const idMapping = dataResult.reduce((acc, el, i) => {
    acc[el.id] = i;
    return acc;
  }, {});

  let root;
  dataResult.forEach((el) => {
    // Handle the root element
    if (el.parent === null) {
      root = el;
      return;
    }
    // Use our mapping to locate the parent element in our dataResult array
    const parentEl = dataResult[idMapping[el.parent]];
    // Add our current el to its parent's `children` array
    parentEl.children = [...(parentEl.children || []), el];
  });
  return root;
}

//Unique array of objects
export function uniqueObjectArray(array, key, keyList) {
  let newSet = [];
  array.forEach((item) => {
    let flag = newSet.filter((ele) => ele[key] === item[key]).length > 0;
    if (!flag) {
      if (keyList.length === 0) {
        newSet.push({ ...item });
      } else {
        let data = {};
        keyList.forEach((ele) => {
          data[ele] = item[ele];
        });
        newSet.push({ ...data });
      }
    }
  });
  return newSet;
}

const decodeHtmlEntity = (html) => {
  const txt = document.createElement("textarea");
  txt.innerHTML = html;
  let val = txt.value;
  txt.remove();
  return val;
};

export function getChangedLanguage(text, stage, language) {
  if (language === "default") {
    return text;
  }
  let translationState = store.getState().language;
  if (translationState.hasOwnProperty(stage)) {
    let stageState = translationState[stage];
    let setData = stageState.filter((ele) => ele.default === text);
    let newText =
      setData.length > 0
        ? setData[0].hasOwnProperty(language)
          ? setData[0][language] !== ""
            ? setData[0][language]
            : text
          : text
        : text;
    return decodeHtmlEntity(newText);
  }
  return text;
}

export function setLanguageData(data, stage, language) {
  let translationState = store.getState().language;
  let currentData = translationState[stage];
  currentData = currentData.map((ele) => {
    return {
      ...ele,
      [language]:
        data.filter((item) => item.default === ele.default).length > 0
          ? data.filter((item) => item.default === ele.default)[0][language]
          : "",
    };
  });
  return currentData;
}

export function checkLanguageData(stage, language) {
  let translationState = store.getState().language;
  let currentData = translationState[stage];
  if (currentData.filter((ele) => ele[language] === "").length > 0)
    return false;
  return true;
}

export function languageUserSessionData() {
  let translationState = store.getState().language;
  var translationStateCookie = localStorage.getItem(
    "conceptx_language_preferences"
  )
    ? JSON.parse(localStorage.getItem("conceptx_language_preferences"))
    : [];

  if (translationStateCookie.length === 0) {
    translationState.checkLanguage = true;
    localStorage.setItem(
      "conceptx_language_preferences",
      JSON.stringify(translationState)
    );
    return translationState;
  } else {
    let newState = {};
    for (let i = 0; i < Object.keys(translationState).length; i++) {
      let ele = Object.keys(translationState)[i];
      let curr = translationState[ele];
      if (translationStateCookie.hasOwnProperty(ele)) {
        if (
          JSON.stringify(translationStateCookie[ele]) !==
          JSON.stringify(translationState[ele])
        ) {
          curr = [];
          if (Array.isArray(translationState[ele])) {
            for (let i = 0; i < translationState[ele].length; i++) {
              if (
                translationStateCookie[ele].filter(
                  (item) => item.default === translationState[ele][i].default
                ).length > 0
              ) {
                curr.push(
                  translationStateCookie[ele].filter(
                    (item) => item.default === translationState[ele][i].default
                  )[0]
                );
              } else {
                curr.push(translationState[ele][i]);
              }
            }
          } else {
            curr = translationStateCookie[ele];
          }
        } else {
          curr = translationState[ele];
        }
      }
      newState[ele] = curr;
    }
    newState.checkLanguage = true;
    localStorage.setItem(
      "conceptx_language_preferences",
      JSON.stringify(newState)
    );
    return newState;
  }
}

export function updateLanguageLocalStorage() {
  let translationState = store.getState().language;
  localStorage.setItem(
    "conceptx_language_preferences",
    JSON.stringify(translationState)
  );
}

export function checkIfparentHasImage(parsedData, parentId, imageList) {
  if (parentId === null) {
    return null;
  }
  if (parsedData.filter((ele) => ele.uuid === parentId).length > 0) {
    if (
      imageList.filter((ele) => ele.asset_class_node.includes(parentId))
        .length > 0
    ) {
      return imageList.filter((ele) => ele.asset_class_node.includes(parentId));
    } else {
      let pid = parsedData.filter((ele) => ele.uuid === parentId)[0].parent;
      parentId =
        parsedData.filter((ele) => ele.id === pid).length > 0
          ? parsedData.filter((ele) => ele.id === pid)[0].uuid
          : null;
      return checkIfparentHasImage(parsedData, parentId, imageList);
    }
  }
  return null;
}
